import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { LoginFailedComponent } from './components/login-failed/login-failed.component';
import { ClientComponent } from './components/admin/client/client.component';

export const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        component: ClientComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'admin',
        loadChildren: () => import('./components/admin/admin.routes').then(m => m.adminRoutes), data: { animation: 'admin' },
      },
    ],
  },
  {
    path: 'login-failed',
    component: LoginFailedComponent,
  },
  { path: 'chat/:id/:embedded', loadChildren: () => import('./components/chat/chat.routes').then(m => m.chatRoutes), data: { animation: 'chat' } },
  { path: '**', redirectTo: 'admin/client' },
];
